module.exports = __webpack_public_path__ + "static/media/multifamily_chart.0b738667.png";